import React from "react";

function useOutsideAlerter(ref: any, setX: any): void {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // function handleClickOutside(event: React.MouseEvent<HTMLElement>) {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setX(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setX]);
}

const Dropdown = (props: {
  button: React.JSX.Element;
  children: React.JSX.Element | ((close: () => void) => React.JSX.Element);
  classNames: string;
  animation?: string;
  fixedOnMobile?: boolean;
}) => {
  const {
    button,
    children,
    classNames,
    animation,
    fixedOnMobile = false,
  } = props;
  const wrapperRef = React.useRef(null);
  const [openWrapper, setOpenWrapper] = React.useState(false);
  useOutsideAlerter(wrapperRef, setOpenWrapper);

  const closeDropdown = () => {
    setOpenWrapper(false);
  };

  return (
    <div ref={wrapperRef} className="relative flex cursor-pointer">
      <div className="flex" onMouseDown={() => setOpenWrapper(!openWrapper)}>
        {button}
      </div>
      <div
        className={`${classNames} ${
          fixedOnMobile
            ? "pointer-events-none fixed inset-0 w-full md:pointer-events-auto md:absolute md:inset-auto md:w-auto"
            : "absolute"
        } z-10 ${
          animation
            ? animation
            : "origin-top-right transition-all duration-300 ease-in-out"
        } ${openWrapper ? "scale-100" : "scale-0"}`}
      >
        {typeof children === "function" ? children(closeDropdown) : children}
      </div>
    </div>
  );
};

export default Dropdown;
